import React from 'react';
import { observer } from 'mobx-react-lite';
import { CountrySettingsType, SingleCountrySettingsType } from 'src/api/config/admin/getCountries';
import FLAGS from './assets/flags.png';

type CountriesListPropsType = {
    countries: CountrySettingsType
    onCountrySelect: (country: SingleCountrySettingsType) => void
}

export const CountriesList = observer((props: CountriesListPropsType) => {

    return (
        <div className='countries-list'>
            <ul className='countries-list__list'>
                {
                    Object.values(props.countries).sort((v1, v2) => v1.name.localeCompare(v2.name)).map(
                        c => (
                            <li className={'color-' + Object.values(c.services).filter(u => u ).length}
                                key={ c.id } onClick={ () => props.onCountrySelect(c) }
                            >
                                <span className={'flag ' + 'flag-' + c.id.toLowerCase()} style={{ backgroundImage: `url(${FLAGS})` }} />
                                <span className='countries-list__name'>
                                    { c.name }
                                </span>
                            </li>
                        )
                    )
                }
            </ul>
        </div>
    );
});
